module.exports = __webpack_public_path__ + "static/media/DSC_0019.e2b14231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0019.jpg
// module id = 586
// module chunks = 0